module.exports = __webpack_public_path__ + "static/media/penn-logo.3a405006.png";